const firebase = require("firebase/app");
require("firebase/database");
require("firebase/firestore");
require("firebase/storage");

export const getBien = (id, callback) => {
  firebase
    .firestore()
    .collection("biens")
    .where("id", "==", id)
    .get()
    .then(snap => {
      snap.docs.map(doc => {
        callback(doc.data());
        // this.data = doc.data();
        // this.paths[2].text = this.data.name + " / " + this.data.localisation;
        // getImages(this.id, (images) => {
        //   this.images = images;
        //   this.loading = false;
        // });
      });
    })
    .catch(e => {
      console.log(e);
    });
};

export const publishBien = async (arg, images) => {
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("biens")
      .add({})
      .then(doc => {
        let id = doc.id;
        arg.id = id;

        if (images) {
          images.forEach(img => {
            firebase
              .storage()
              .ref("biens/" + id + "/" + img.name)
              .put(img);
          });
        }

        firebase
          .firestore()
          .collection("biens")
          .doc(id)
          .set(arg)
          .then(r => resolve(r))
          .catch(err => reject(err));
      })
      .catch(err => reject(err));
  });
};

export const deleteBien = (id, callback) => {
  firebase
    .firestore()
    .collection("biens")
    .doc(id)
    .delete()
    .then(() => {
      firebase
        .storage()
        .ref("biens/" + id)
        .listAll()
        .then(res => {
          res.items.forEach(item => item.delete());
        })
        .then(() => callback());
    });
};
